import { isShapeImage } from '../objects/guards';
import Tool, { type IToolAvailableInput, simpleToolButton } from './Tool';

class ToolDownloadImage extends Tool {
  static toolName = 'Download image';

  static action({ selection }) {
    selection.shape.downloadImage();
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolDownloadImage,
      'fa-regular fa-arrow-down-to-square'
    );
  }

  // Check if the tool action should be available. Useful for hiding a menu
  // item based on context/selection.
  static available({ selection }: IToolAvailableInput) {
    if (!selection) {
      return false;
    }
    if (!isShapeImage(selection)) {
      return false;
    }
    return !!selection.shape.image;
  }
}

export default ToolDownloadImage;
